import { render, staticRenderFns } from "./ArticleSidebar.vue?vue&type=template&id=70e27482&scoped=true&"
import script from "./ArticleSidebar.vue?vue&type=script&lang=js&"
export * from "./ArticleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSidebar.vue?vue&type=style&index=0&id=70e27482&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e27482",
  null
  
)

export default component.exports